export default "__VITE_ASSET__CeqIkocx__"